export default __webpack_public_path__ + "static/media/bb3.12caaeb4.png";